import React from 'react'
import { Nav } from 'react-bootstrap'
import {
  admin_alert_automation_audit_logs_path,
  admin_alert_automation_business_errors_path,
  admin_alert_automation_scenarios_path
} from '../../../../routes'

export type BusinessAlertTab = 'scenarios' | 'business_errors' | 'audit_log'

// With a single tab this renders nothing: a lone tab is noise.
const ALL_TABS: { tab: BusinessAlertTab, title: string, path: () => string }[] = [
  { tab: 'scenarios', title: 'Scenarios', path: admin_alert_automation_scenarios_path },
  { tab: 'business_errors', title: 'Business Errors', path: admin_alert_automation_business_errors_path },
  { tab: 'audit_log', title: 'Audit Log', path: admin_alert_automation_audit_logs_path },
]

interface BusinessAlertTabsProps {
  activeTab: BusinessAlertTab
  canViewScenarios?: boolean
  canViewBusinessErrors?: boolean
  canViewAuditLog?: boolean
}

// Each tab is its own server-rendered page, so selecting one navigates instead of swapping panes.
// The rights are granted separately, so a tab the visitor cannot open is left out rather than
// offered as a link to a 404.
const BusinessAlertTabs = ({
  activeTab,
  canViewScenarios = true,
  canViewBusinessErrors = true,
  canViewAuditLog = true
}: BusinessAlertTabsProps) => {
  const allowed: Record<BusinessAlertTab, boolean> = {
    scenarios: canViewScenarios,
    business_errors: canViewBusinessErrors,
    audit_log: canViewAuditLog
  }
  const TABS = ALL_TABS.filter(({ tab }) => allowed[tab])

  const handleSelect = (tab: string | null) => {
    const selected = TABS.find(({ tab: key }) => key === tab)
    if (!selected || selected.tab === activeTab) return

    window.location.href = selected.path()
  }

  if (TABS.length < 2) return null

  return (
    <Nav
      variant="tabs"
      activeKey={activeTab}
      onSelect={handleSelect}
      fill={true}
      justify={true}
    >
      {TABS.map(({ tab, title }) => (
        <Nav.Item key={tab}>
          <Nav.Link as="button" eventKey={tab}>{title}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  )
}

export default BusinessAlertTabs
